export const LABELING_TITLES = ({
  IMAGE: 'Image Labeling',
  VIDEO: 'Video Labeling',
  PDF: 'PDF Labeling',
  AUDIO_TAGGING: 'Audio Tagging',
  VIDEO_TAGGING: 'Video Tagging',
  DEFAULT: 'Labeling Task'
} as const);
export const VIDEO_FILTERS = ({
  ALL: 'all',
  CURRENT_FRAME: 'current-frame'
} as const);
export const FRAME_THUMBNAIL = ({
  WIDTH: '300px',
  HEIGHT: '169px'
} as const);